export enum TeamSectionDetails {
  Agents = 'agents',
  Chatbots = 'chatbots',
  SuspendedAgents = 'suspendedAgents',
}
